import Cookies from 'js-cookie'

interface OptionsVo {
  id: string
  name: string
}

export interface DataInfo {
  /** token */
  accessToken: string
  /** 用户名 */
  userName?: string
  /** 当前登录用户的角色列表 */
  roles?: Array<OptionsVo>
  /** 当前的选中roleId */
  roleId?: string
  /** 当前的选中orgId */
  orgId?: string
  /** 当前登录用户在当前角色下的科室列别哦 */
  orgs?: Array<OptionsVo>
  apps: any
}

export const sessionKey = 'user-info'
export const TokenKey = 'authorized-token'

/** 获取`token` */
export function getToken(): string {
  // 此处与`TokenKey`相同，此写法解决初始化时`Cookies`中不存在`TokenKey`报错
  // return Cookies.get(TokenKey)
  return sessionStorage.getItem(TokenKey)
}

/**
 * @description 设置`toke`
 */
export function setToken(data: string) {
  // Cookies.set(TokenKey, data)
  sessionStorage.setItem(TokenKey, data)
}

/** 删除`token`以及key值为`user-info`的session信息 */
export function removeToken() {
  Cookies.remove(TokenKey)
  sessionStorage.clear()
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}
